import { getItemMaker } from "./tools";

const i = getItemMaker("trophies");
export const trophies = [
  i("King of Food"),
  i("Lucky Lad", "Trophy2"),
  i("Club Member", "Trophy3"),
  i("Dice Dynamo", "Trophy5"),
  i("Blunder Hero", "Trophy6"),
  i("Trailblazer"),
  i("Ultra Unboxer"),
  i("Critter Baron", "Trophy10"),
  i("YumYum Sheriff"),
  i("Megalodon"),
  i("Club Maestro", "Trophy13"),
  i("Beach Bro"),
  i("Frost Prince"),
  i("Idle Skiller"),
  i("One of the Divine"),
  i("Master of Nothing"),
  i("Nebula Royal"),
  i("Luckier Lad"),
  i("Baller"),
  i("Gladiator"),
];
